import React, { useState } from 'react';
import { FaPaperPlane, FaUser, FaEnvelope, FaPhone, FaTag, FaComment } from 'react-icons/fa';
import axios from 'axios';
import './PageCss/Contact.css';
import { contactService } from '../services/contactService';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      formData.submittedAt = new Date().toISOString();
      formData.ipAddress = null;
      var response = await contactService.create(formData);
      //showNotification('Contact created successfully');

      if (response.success) {
        setStatus({ loading: false, success: true, error: null });
        setFormData({
          fullName: '',
          email: '',
          phoneNumber: '',
          subject: '',
          message: ''
        });
      }
      else{
        setStatus({
          loading: false,
          success: false,
          error: response?.message || 'Failed to send message. Please try again.'
        });
      }
    } catch (error) {
      setStatus({
        loading: false,
        success: false,
        error: response?.data?.message || 'Failed to send message. Please try again.'
      });
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <h2>Get in Touch</h2>
          <p>Have a question or want to work together? Send us a message!</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card">
              <h3>Contact Information</h3>
              <p>Feel free to reach out to us for any inquiries or collaborations.</p>
              <div className="info-details">
                <p><FaEnvelope /> contact@codebit.com</p>
                <p><FaPhone /> +977 98672882...</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-icon">
                <FaUser />
              </div>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Full Name"
                required
              />
            </div>

            <div className="form-group">
              <div className="input-icon">
                <FaEnvelope />
              </div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address"
                required
              />
            </div>

            <div className="form-group">
              <div className="input-icon">
                <FaPhone />
              </div>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="Phone Number (Optional)"
              />
            </div>

            <div className="form-group">
              <div className="input-icon">
                <FaTag />
              </div>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Subject"
                required
              />
            </div>

            <div className="form-group">
              <div className="input-icon">
                <FaComment />
              </div>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                required
              />
            </div>

            {status.error && (
              <div className="error-message">
                {status.error}
              </div>
            )}

            {status.success && (
              <div className="success-message">
                Message sent successfully! We'll get back to you soon.
              </div>
            )}

            <button 
              type="submit" 
              className="submit-button"
              disabled={status.loading}
            >
              {status.loading ? (
                <span className="loading-spinner" />
              ) : (
                <>
                  <FaPaperPlane />
                  Send Message
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
